(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              // No recommendations found, use fallback template if it has content
              const template = this.querySelector('template');
              if (template && template.content.querySelector('.product-card')) {
                const templateContent = template.content.cloneNode(true);
                this.innerHTML = '';
                this.appendChild(templateContent);
                this.dispatchEvent(new CustomEvent('recommendations:loaded'));
              } else {
                this.closest('.shopify-section').remove();
                this.dispatchEvent(new CustomEvent('recommendations:empty'));
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-steps"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', (e) => {
    document.querySelectorAll('.step-nav').forEach((item) => {
        item.addEventListener('click', (e) => {
            const el = document.querySelector(`.product-steps__step[data-step="${item.dataset.target}"]`);
            window.scrollTo({
                top: el.offsetTop - 120,
                behaviour: 'smooth'
            })
        });
    });

    document.querySelectorAll('.js-step-scroll').forEach((wrapper) => {
        let productCardImage = wrapper.querySelector('.product-card .primary-image'),
        scrollControls = wrapper.querySelector('.js-scroll-controls');

        if(!!scrollControls){
            scrollControls.style.top = `${Math.round(productCardImage.clientHeight / 2 + 14)}px`;
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
